import { Routes } from '@angular/router';
import { Injectable, inject  } from '@angular/core';
// import { OktaAuthGuard, OktaCallbackComponent, OktaLoginRedirectComponent } from '@okta/okta-angular';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';

import { AuthProfileComponent } from '@shared/modules/auth/components/auth-profile.component';
import { ClientSelectionComponent } from '@shared/components/client-selection/client-selection.component';
import { LayoutComponent } from '@shared/components/layout/layout.component';
import { AuthGuard } from '@shared/guards/auth.guard';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular'; 
import { environment } from '@environments/environment';
import { OktaAuth } from '@okta/okta-auth-js';
import { LoginComponent } from '@shared/components/login/login.component';
const oktaAuth = new OktaAuth(environment.okta);


export const routes: Routes = [
  {
    path: 'auth/login',
    component: LoginComponent // //OktaLoginRedirectComponent // oktaAuth.signInWithRedirect()
  },
  {
    path: 'auth/callback',
    component: OktaCallbackComponent
  },
  {
    path: 'auth/profile',
    component: AuthProfileComponent
  },
  {
    path: 'client-selection',
    component: ClientSelectionComponent
  },
  {
    path: 'dashboard',
    canLoad: [AuthGuard],
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./modules/dashboard/dashboard.routes').then(m => m.routes)
  },
  {
    path: 'reports',
    canLoad: [AuthGuard],
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./modules/reports/reports.routes').then(m => m.routes)
  },
  {
    path: '',
    redirectTo: 'client-selection',
    pathMatch: 'full'
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'general-information',
        redirectTo: 'organizational-unit/general-information'
      },
      {
        path: 'premise-linking',
        redirectTo: 'organizational-unit/premise-linking'
      },
      {
        path: 'library',
        redirectTo: 'organizational-unit/library'
      },
      {
        path: 'tasks',
        redirectTo: 'continuity-plan/tasks'
      },
      {
        path: 'processes',
        redirectTo: 'continuity-plan/processes'
      },
      {
        path: 'events',
        redirectTo: 'continuity-plan/events'
      },
      {
        path: 'tests',
        redirectTo: 'continuity-plan/tests'
      },
      {
        path: 'macro-process',
        redirectTo: 'administration/macro-process'
      },
      {
        path: 'process-area',
        redirectTo: 'administration/process-area'
      },
      {
        path: 'process-category',
        redirectTo: 'administration/process-category'
      },
      {
        path: 'profiles',
        redirectTo: 'administration/profiles'
      },
      {
        path: 'users',
        redirectTo: 'administration/users'
      },
      {
        path: 'invalidation-configuration',
        redirectTo: 'administration/invalidation-configuration'
      },
      {
        path: 'user-guide',
        redirectTo: 'administration/user-guide'
      },
      {
        path: 'download-reports',
        redirectTo: 'administration/download-reports'
      },
      {
        path: 'organizational-unit',
        canLoad: [AuthGuard],
        canActivate: [OktaAuthGuard],
        loadChildren: () => import('./modules/organizational-unit/organizational-unit.routes').then(m => m.routes)
      },
      {
        path: 'human-resources',
        canLoad: [AuthGuard],
        canActivate: [OktaAuthGuard],
        loadChildren: () => import('./modules/human-resource/human-resource.routes').then(m => m.routes)
      },
      {
        path: 'continuity-plan',
        canLoad: [AuthGuard],
        canActivate: [OktaAuthGuard],
        loadChildren: () => import('./modules/continuity-plan/continuity-plan.routes').then(m => m.routes)
      },
      {
        path: 'resource',
        canLoad: [AuthGuard],
        canActivate: [OktaAuthGuard],
        loadChildren: () => import('./modules/resources/resources.routes').then(m => m.routes)
      },
      {
        path: 'administration',
        canLoad: [AuthGuard],
        canActivate: [OktaAuthGuard],
        loadChildren: () => import('./modules/administration/administration.routes').then(m => m.routes)
      }
    ]
  }
];
